const Stock = () => {
  return (
    <div className="content-page-admin">
      <div className="title-page-admin">
        <i className="bx bx-coin-stack"></i>
        <p>Stock page</p>
      </div>
    </div>
  );
};

export default Stock;
